import _ from 'underscore';
import React, { useMemo, useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  mergeClasses,
} from '@fluentui/react-components';
import { Tag } from '@fluentui/react-tags';

import { getAllExpandStepIds, parseStepConfig } from './utils';
import { useTopStepProgressBarStyle } from './styles/top-step-progress-bar-style';

interface TopStepProgressBarProps {
  classes?: {
    root?: string;
  };
  config: Array<{
    id: string;
    title?: string;
    steps: Array<{
      id: string;
      title?: string;
    }>;
  }>;
  currentStepId: string;
  currentFlow?: Array<string>;
}

export const TopStepProgressBar: React.FC<TopStepProgressBarProps> = (props) => {
  const {
    config, currentStepId,
  } = props;
  const i18n = useContext(I18nContext);
  const classes = useTopStepProgressBarStyle();

  const currentFlow = useMemo(() => {
    if (props.currentFlow) {
      return props.currentFlow;
    }
    return getAllExpandStepIds(config);
  }, [config, props.currentFlow]);

  const steps = useMemo(() => parseStepConfig(config, currentStepId, currentFlow), [config, currentFlow, currentStepId]);

  const currentStep = useMemo(() => _.find(steps, (step) => step.id === currentStepId), [currentStepId, steps]);
  const parentStep = useMemo(() => _.find(steps, (step) => _.find(step.steps, (subStep) => subStep.id === currentStepId)), [currentStepId, steps]);
  const currentIndex = currentFlow.indexOf(currentStepId);

  return (
    <div className={mergeClasses('top-step-progress-bar', classes.listContainer, props.classes?.root)}>
      <div className={mergeClasses('current-step-title-container', classes.titleContainer)}>
        {parentStep && parentStep.title && <div className={mergeClasses('parent-step-title', classes.parentStepTitle)} title={parentStep.title}>{parentStep.title}</div>}
        <div
          className={mergeClasses('current-step-title', classes.title)}
          title={currentStep.title}
        >
          {currentStep.title || ''}
        </div>
      </div>
      <Tag shape="circular" appearance="outline" className={mergeClasses('step-progress', classes.tag)}>
        {i18n.getString(_TL_('Step {{currentIndex}} of {{totalSteps}}'), { currentIndex: (currentIndex + 1).toString(), totalSteps: currentFlow.length.toString() })}
      </Tag>
    </div>
  );
};

TopStepProgressBar.defaultProps = {
  currentFlow: undefined,
};
